import React from 'react';
import Grid from '@material-ui/core/Grid';
import {Styles} from '../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import BreadCrumbs from "../../components/elements/BreadCrumbs";
import {Translate} from "../../../config/Translate";
import AppCard from "../../components/layouts/components/AppCard";
import AppAnimate from "../../components/AppAnimate";
import {withRouter} from "react-router";
import {withSnackbar} from "notistack";
import {connect} from "trim-redux";
import MakeShop from "./parts/MakeShop";

class RequestSupplierPage extends React.Component {
    id = !!this.props.user.shops[0] ? this.props.user.shops[0].id : null;
    render() {
        return(
            <AppAnimate animation='transition.slideUpIn' delay={200} title={Translate.RequestSupplierPage}>
                <Grid container spacing={2} justify="center">
                    <Grid item xs={12}>
                        <AppCard
                            title={Translate.RequestSupplierPage}
                            action={
                                <BreadCrumbs singleLevel firstText={Translate.RequestSupplierPage}/>
                            }>
                            <MakeShop new_request edit={!!this.id} shop_id={!!this.id ? this.id : 0 }/>
                        </AppCard>
                    </Grid>
                </Grid>
            </AppAnimate>
        )
    }
}
const mstp = state => ({
    isAuth: state.isAuth,
    user: state.user
});
export default withRouter(withSnackbar(withStyles(Styles)(connect(mstp)(RequestSupplierPage))));